import { render, staticRenderFns } from "./out-comp-card.vue?vue&type=template&id=3a9c734e&scoped=true"
import script from "./out-comp-card.vue?vue&type=script&lang=js"
export * from "./out-comp-card.vue?vue&type=script&lang=js"
import style0 from "./out-comp-card.vue?vue&type=style&index=0&id=3a9c734e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9c734e",
  null
  
)

export default component.exports